/**
 * Removes the local drafts of a user (logout, threat model T11). Loads the IndexedDB module on demand, so the session
 * code does not bring Dexie into the first screen's bundle.
 */
export async function clearUserData(userId: string): Promise<void> {
  const db = await import('./db.ts');
  await db.clearUserData(userId);
}
